import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OrganizationProvince } from '../model/organization/organization-province.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProvinceService {
  private httpClient = inject(HttpClient);

  public getProvinceList(): Observable<OrganizationProvince[]> {
    return this.httpClient.get<any[]>(
      `${environment.apiUrl}/api/provinces`,
    ).pipe(
      map((responseList: any[]): OrganizationProvince[] => (responseList ?? []).map(
        (response: any): OrganizationProvince => OrganizationProvince.createFromApi(response),
      )),
    );
  }
}
